const getProductTemplateDataset = () => document.querySelector("#product-detail-page").dataset;

export default getProductTemplateDataset;